export enum BasicConfiguration {
    BIAS = "BIAS - BIAS-F",
    ASCON = "Ascon"
}

export enum LensConfigMode {
    DUAL = "DUAL",
    SINGLE = "SINGLE"
}

export enum LensSectionMode {
    TRIAL_LENS = "TRIAL_LENS",
    FINAL_LENS = "FINAL_LENS",
    HECHT_PROPOSAL = "HECHT_PROPOSAL",
    TRIAL_LENS_COPY = "TRIAL_LENS_COPY",
    FINAL_LENS_COPY = "FINAL_LENS_COPY",
    CARE = "CARE",
    ACCESSORIES = "ACCESSORIES",
    ORDER_CONFIRM ="ORDER_CONFRIM"
}

export enum LensSide {
    RIGHT = "RIGHT",
    LEFT = "LEFT"
}

export enum LensType {
    HARD = "HARD",
    SOFT = "SOFT"    
}